import { render, staticRenderFns } from "./depense_edit.vue?vue&type=template&id=2c15c1a3&"
import script from "./depense_edit.vue?vue&type=script&lang=js&"
export * from "./depense_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports